/**
 * View component for /user-profiles/new
 *
 * Creates a new userProfile from a copy of the defaultItem in the userProfile reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userProfileActions from '../userProfileActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userProfile components
import UserProfileForm from '../components/UserProfileForm.js.jsx';
import UserProfileLayout from '../components/UserProfileLayout.js.jsx';

class CreateUserProfile extends Base {
  constructor(props) {
    super(props);
    this.state = {
      userProfile: _.cloneDeep(this.props.defaultUserProfile)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newUserProfileState = _.update( this.state.userProfile, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userProfile :newUserProfileState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userProfileActions.sendCreateUserProfile(this.state.userProfile)).then((action) => {
      if(action.success) {
        dispatch(userProfileActions.invalidateList());
        history.push(`/user-profiles/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { userProfile } = this.state;
    const isEmpty = (userProfile.name === null || userProfile.name === undefined);
    return (
      <UserProfileLayout>
        <div className="flex">
          <Helmet
            title={"New Profile | Pro-ficiency"}
          />
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <UserProfileForm
                userProfile={userProfile}
                cancelLink="/user-profiles"
                formTitle="Create User Profile"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </UserProfileLayout>
    )
  }
}

CreateUserProfile.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultUserProfile: store.userProfile.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateUserProfile)
);



// WEBPACK FOOTER //
// modules/userProfile/views/CreateUserProfile.js.jsx